import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DATA_VIZ_COLORS } from "../../../config/chartColors";
import type { VocabularyGrowthPoint } from "../../../generated/graphql";

interface VocabularyGrowthChartProps {
  data: VocabularyGrowthPoint[];
}

export function VocabularyGrowthChart({ data }: VocabularyGrowthChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No vocabulary growth data available</div>
      </div>
    );
  }

  const chartData = data.map((point) => ({
    date: new Date(point.date).toLocaleDateString(),
    total: point.totalWords,
    mastered: point.masteredWords,
    newDaily: point.newWords,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Vocabulary Growth</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={DATA_VIZ_COLORS.primary} stopOpacity={0.8} />
                <stop offset="95%" stopColor={DATA_VIZ_COLORS.primary} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorMastered" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={DATA_VIZ_COLORS.success} stopOpacity={0.8} />
                <stop offset="95%" stopColor={DATA_VIZ_COLORS.success} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis label={{ value: "Words", angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Legend />
            <Area
              type="monotone"
              dataKey="total"
              stroke={DATA_VIZ_COLORS.primary}
              fillOpacity={1}
              fill="url(#colorTotal)"
              name="Total Words"
            />
            <Area
              type="monotone"
              dataKey="mastered"
              stroke={DATA_VIZ_COLORS.success}
              fillOpacity={1}
              fill="url(#colorMastered)"
              name="Mastered"
            />
            <Line
              type="monotone"
              dataKey="newDaily"
              stroke={DATA_VIZ_COLORS.warning}
              strokeWidth={2}
              dot={{ r: 3 }}
              name="New (Daily)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
